export const CONFIG = {
    domain: 'http://virtualspa.mrsteam.com/api' // This should be used in case a webapi will be implemented
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./config/config.ts